import type { ComponentProps } from "react"
import { TabsContent as TabsContentBase } from "@/v2-ui/tabs/base/TabsBase"
import cn from "@/v2-ui/utils/utils.cn"

export type TabsContentProps = ComponentProps<typeof TabsContentBase>

function TabsContent(props: TabsContentProps) {
  const { className, ...tabsContentBaseProps } = props
  return (
    <TabsContentBase
      className={cn(
        "ui-tabs-content ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 [&[data-orientation=vertical]]:ml-2 [&[data-orientation=horizontal]]:mt-2",
        className,
      )}
      {...tabsContentBaseProps}
    />
  )
}

export default TabsContent
